export const calculateTipAmount = (total: number, tipPercentage: number): number => {
  const tipAmount = (total / 100) * tipPercentage;

  return Math.ceil(tipAmount * 100) / 100;
};

export const calculateTotal = (total: number, tipPercentage: number): number =>
  total + calculateTipAmount(total, tipPercentage);

export default {};
